export default {
    methods: {
        removeAttachment(attachmentToRemove) {
            const index = this.attachments.findIndex((attachment) => {
                if (attachment.id && attachmentToRemove.id) {
                    return attachment.id === attachmentToRemove.id;
                }

                if (attachment.content_id && attachmentToRemove.content_id) {
                    return attachment.content_id === attachmentToRemove.content_id;
                }

                if (attachment.tempId && attachmentToRemove.tempId) {
                    return attachment.tempId === attachmentToRemove.tempId;
                }

                return false;
            });
            if (index !== -1) {
                this.attachments.splice(index, 1);
            }
        },
        updateAttachmentList(file) {
            const baseFileName = file.name.split('.')[0];
            const index = this.attachments.findIndex((attachment) => {
                const attachmentBaseName = attachment.name.split('.')[0];
                return (
                    attachmentBaseName === baseFileName &&
                    attachment.size === file.size &&
                    attachment.isFileLoaded === true
                );
            });
            if (index !== -1) {
                this.attachments.splice(index, 1, file);
            } else {
                this.attachments.push(file);
            }
        },
    },
};
